// Get All the users assoiated to the Group
export const ADMIN_API_GET_INSTUSERS_REQUEST = 'ADMIN_API_GET_INSTUSERS_REQUEST';
export const ADMIN_API_GET_INSTUSERS_SUCCESS = 'ADMIN_API_GET_INSTUSERS_SUCCESS';
export const ADMIN_API_GET_INSTUSERS_FAILURE = 'ADMIN_API_GET_INSTUSERS_FAILURE';
